export default "__VITE_ASSET__DNXjF6Dz__"